module.exports = __webpack_public_path__ + "static/media/KhalidMerajKhan.49c6a825.jpeg";